import Layout from "../../layouts";
import { useState, useEffect } from "react";
import { DatePartsPicker, MyDate } from "src/components/date-parts-picker";
import {Calendar22} from "../../components/ui/date-picker";
import { Calendar } from "src/components/ui/calendar";
import DatePicker from "src/components/date-picker";
import { PlusIcon } from "lucide-react";

const Dashboard = () => {
  const [date, setDate] = useState<any>("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Fake API delay
    document.title = "Dashboard - SummerYou"
    setTimeout(() => setLoading(false), 3000);
  }, []);
  
  const [dob, setDob] = useState<Partial<MyDate> | null>(null)

  return (
    <>
      <div className="p-2 lg:px-2 overflow-hidden">
        <div className="lg:mx-0 lg:max-w-none overflow-hidden">
          <div className="absolute inset-0 flex items-center" aria-hidden="true">
              {/* <div className="w-full border-t border-gray-300" /> */}
          </div>
          <div className="relative flex items-center justify-between">
              <span className="bg-white pr-3 text-2xl font-semibold text-neutral-600">Dashboard</span>
          </div>          
        </div>
      </div>
    </>
  )
}


export default Dashboard;